import React, {Component} from 'react';
import * as apis from '../../utils/apis';
import { connect } from "react-redux";

import DataGrid, {
    Column,
    Editing,
    Popup,
    Position,
    GroupPanel,
    FilterPanel,
    FilterRow,
    ColumnChooser,
    Scrolling,
    RequiredRule,
    FormItem
} from 'devextreme-react/ui/data-grid';
import { StringLengthRule } from 'devextreme-react/validator';


const getHeight = () => {
    return (window.innerHeight - 48)
}

class PartRequestStatusesGrid extends Component {
    state = {
    };

    resize = () => {
        this.gridview.instance.option('height',getHeight());
      }
    
      componentDidMount() {
        window.addEventListener('resize', this.resize)
      }
      
      componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
      }

      setDefaultNewValues = (e) => {
        e.data.active = true;
        e.data.default= false;
        e.data.isFullyComplete = false;
        e.data.cancelled = false;
        e.data.used = false;
      }

      onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
              icon: 'refresh',
              onClick: this.refreshGrid 
            }
          });
    }

    refreshGrid = () => {
        this.gridview.instance.refresh(true);
    }

    render() {
        return  (
            <DataGrid 
            dataSource={apis.PartRequestStatusesDataSource(this.props.user.access_token)}  
            noDataText="There are no part request statuses defined."
            rowAlternationEnabled={true}  
            showBorders={true}
            showRowLines={true}
            showColumnLines={true}  
            columnHidingEnabled={false}
            allowColumnReordering={true}
            allowColumnResizing={true}
            stateStoring={{ enabled: 'true',type: 'localStorage', storageKey: 'prStatuses' }}
            height={getHeight}
            width="100%" ref={(gv) => {this.gridview = gv}} 
            onInitNewRow={this.setDefaultNewValues} onToolbarPreparing={this.onToolbarPreparing}
         >
          <Editing
            mode={'popup'}
            allowUpdating={this.props.grants.rights.adminPRStatus}
            allowDeleting={this.props.grants.rights.adminPRStatus}
            allowAdding={this.props.grants.rights.adminPRStatus} >
             <Popup title={'Part Request Status'} showTitle={true}>
              <Position my={'center'} at={'center'} of={window} />
            </Popup>
            </Editing>
        <Scrolling mode="virtual" />
        <GroupPanel visible={true} />
        <FilterRow visible={true} />
        <FilterPanel visible ={true} />
  
        <ColumnChooser enabled={true} />
        {/* <StateStoring enabled={true} storageKey="this.props.sectionId" /> */}

        <Column dataField={'id'} visible={false}>
            <FormItem visible={false} />
        </Column>
        <Column dataField={'text'} caption="Status" >
            <RequiredRule message="Status is required." />
            <StringLengthRule max="100" message="The status text cannot exceed 100 characters."/>
        </Column>
        <Column dataField={'default'} />
        <Column dataField={'isFullyComplete'} caption="Complete" />
        <Column dataField={'cancelled'} />
        <Column dataField={'used'} />
        <Column dataField={'active'} />
        </DataGrid>
        );
    }


}

const mapStateToProps = (state) => {
  return {
      user: state.oidc.user,
      grants: state.rights
  };
}

export default connect(mapStateToProps, null)(PartRequestStatusesGrid)